import { useApi } from 'src/hooks/useApi';
import { urlJoin } from 'src/utils/util';


const resourceName = 'isic';

const useIsicApi = () => {
  const { get, post } = useApi();
  return {
    getOptions: async queryParams => (await get(urlJoin(resourceName, `options`), queryParams)).data,
    saveIsic: async isicData => (await post(urlJoin(resourceName, `save`), isicData)).data,
  };
};


export { useIsicApi };